import { StringHelper } from "../../../../../../helper";
import { AFLType } from "../../models";

export const form37 = (record: any) => {
  return {
    departmentCode: "3",
    aflType: AFLType.ApplicationForLeave,
    layout: [
      {
        type: "header",
        value: {
          form: 1,
          department: "CHI NHÁNH ĐÀ NẴNG",
        },
      },
      {
        type: "title",
        value: {
          sub: [
            `(Dành cho Phó Giám đốc Chi nhánh nghỉ từ 3 ngày trở lên, `,
            `Cán bộ Phòng/TT Chi nhánh nghỉ từ 05 ngày trở lên)`,
          ],
        },
      },
      {
        type: "salutation",
        value: ["Tổng Giám đốc VIAGS;", "Giám đốc Chi nhánh Đà Nẵng."],
      },
      {
        type: "content",
        value: [
          { type: "eRequestName", value: record?.eRequestName },
          {
            type: "ePosition",
            value: StringHelper.verticalBarSplit<string[]>(record?.eTitle)[1],
          },
          {
            type: "eWorkPlaceDeptCenter2",
            value: StringHelper.verticalBarSplit<string[]>(record?.eUnit)[1],
          },
          {
            type: "",
            value: `Nay tôi làm đơn này kính đề nghị Ông Tổng giám đốc VIAGS/ Giám đốc Chi nhánh Đà Nẵng đồng ý giải quyết cho tôi được nghỉ phép năm ${new Date().getFullYear()} lần thứ ${
              record?.ePaidLeaveTimes || ""
            }.`,
          },
          {
            type: "",
            value: `Số lượng phép theo tiêu chuẩn: ${
              record?.ePaidLeaveRemain + "" || ""
            } ngày (trong TH nghỉ phép từ lần thứ 2 trở đi, chỉ ghi rõ số ngày phép còn lại chưa thực hiện).`,
          },

          { type: "eVacationPeriod", value: record?.eVacationPeriods[0] },
          { type: "eLeavePlace", value: record?.eLeavePlace || "" },
          { type: "eProxy", value: [record?.eProxyId, record?.eProxyFor] },
          { type: "ePhoneNumber", value: record?.ePhone || "" },
          { type: "eReason", value: record?.eReason },
          {
            type: "",
            value: "Rất mong nhận được sự chấp thuận của Tổng Giám đốc và Giám đốc Chi nhánh Đà Nẵng.",
          },
          { type: "", value: "Xin trân trọng cảm ơn./." },
        ],
      },
      {
        type: "footer",
        value: [
          {
            type: "recipients",
            value: ["- Như trên;", "- TCNL, VPCT;", "- Lưu KHHC."],
          },
          {
            type: "signature1",
            value: ["NGƯỜI LÀM ĐƠN", record?.eRequestName],
          },
        ],
      },
      {
        type: "footer",
        value: [
          {
            type: "signature1",
            value: ["XÁC NHẬN CỦA GIÁM ĐỐC CHI NHÁNH ĐÀ NẴNG", record?.eSteps[1][0].name],
          },
        ],
        textBreak: 1,
      },
      {
        type: "footer",
        value: [
          {
            type: "signature1",
            value: ["PHÊ DUYỆT CỦA TỔNG GIÁM ĐỐC", record?.eSteps[2][0].name],
          },
        ],
        textBreak: 1,
      },
    ],
  };
};
